import React, {Component} from 'react';
import noPermissions from "../../../images/noPermissions.png"

class NoPermissions extends Component {
    render() {
        return (
            <div className={'no_permissions'}>
                <img src={noPermissions}/>
            </div>
        );
    }
}

export default NoPermissions;